import React from 'react';
import { Route } from 'react-router-dom';
import Project from './Project';

export default function Projects({ match }) {
  return <Route path={`${match.path}/:projectId`} component={Project} />;
}
